<template>
    <va-edit-layout>
        <AdsConfiguration-form
            :id="id"
            :title="title"
            :item="item"
        ></AdsConfiguration-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
